import { LitElement, html } from "lit-element";
import { property } from "lit/decorators.js";

class ActivatePage extends LitElement {
  errors: any = {};
  @property({ type: String }) message: any;

  static get properties() {
    return {
      errors: { type: Object },
    };
  }

  constructor() {
    super();

    this.getActivation();
  }

  render() {
    return html`
      <div class="auth-container">
        <h1>Activate Account</h1>

        ${this.message
          ? html`<div class="form-success-message">${this.message}</div>`
          : html``}

        <p class="form-message">
          Already activated?
          <a href="/" class="login-link">Login</a>
        </p>
      </div>
    `;
  }

  getActivation() {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");

    if (code && window.location.pathname.includes("activate")) {
      fetch(`${process.env.BASE_API_URL}/activate`, {
        method: "POST",
        body: JSON.stringify({ code }),
      })
        .then((response) => response.json())
        .then((data) => {
          this.message = data.message;
        })
        .catch((error) => {
          console.error("Error during activation:", error);
          alert("An error occurred. Please try again later.");
        });
    }
  }

  protected createRenderRoot() {
    return this;
  }
}

customElements.define("activate-page", ActivatePage);
